/* LUZ NOVA — global behaviors */
(function () {
  "use strict";

  /* ----- Toast helper ----- */
  function toast(msg, isError) {
    var el = document.getElementById("CartToast");
    if (!el) return;
    var msgEl = el.querySelector(".cart-toast__msg");
    if (msgEl) msgEl.textContent = msg;
    el.style.borderColor = isError ? "var(--danger)" : "var(--accent)";
    el.hidden = false;
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.hidden = true; }, 4000);
  }

  /* ----- Mobile drawer ----- */
  const drawer = document.getElementById("MobileDrawer");
  document.querySelectorAll("[data-drawer-open]").forEach((btn) =>
    btn.addEventListener("click", () => drawer && drawer.classList.add("is-open"))
  );
  document.querySelectorAll("[data-drawer-close]").forEach((btn) =>
    btn.addEventListener("click", () => drawer && drawer.classList.remove("is-open"))
  );

  /* ----- Mobile facets ----- */
  const facets = document.getElementById("FacetsWrap");
  document.querySelectorAll("[data-facets-open]").forEach((btn) =>
    btn.addEventListener("click", () => facets && facets.classList.add("is-open"))
  );
  document.querySelectorAll("[data-facets-close]").forEach((btn) =>
    btn.addEventListener("click", () => facets && facets.classList.remove("is-open"))
  );

  /* ----- Auto-submit facet form ----- */
  const facetForm = document.getElementById("FacetForm");
  if (facetForm) {
    facetForm.addEventListener("change", () => {
      if (window.LuzAjaxFacets) { window.LuzAjaxFacets.submit(); } else { facetForm.submit(); }
    });
  }
  const sortSelect = document.getElementById("SortBy");
  if (sortSelect) {
    sortSelect.addEventListener("change", () => {
      const url = new URL(window.location.href);
      url.searchParams.set("sort_by", sortSelect.value);
      url.searchParams.delete("page");
      if (window.LuzAjaxFacets) { window.LuzAjaxFacets.navigate(url.href); } else { window.location.href = url.href; }
    });
  }

  /* ====================================================================
     SMART SEARCH — predictive dropdown with thumbnails/prices, highlighted
     matches, categorized sections (Products / Categories / Articles),
     client-side fuzzy typo correction, personalized suggestions on focus,
     a full-screen overlay on mobile, and lightweight search analytics.
     ==================================================================== */
  (function () {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
    var MOBILE_BQ = 749;
    var RECENT_KEY = "luz_recent_searches";
    var VIEWED_KEY = "luz_recently_viewed";

    var css = document.createElement("style");
    css.textContent =
      ".predictive{position:absolute;top:calc(100% + 8px);left:0;right:0;background:var(--surface);" +
      "border:1px solid var(--line);border-radius:12px;overflow:hidden;z-index:120;" +
      "box-shadow:0 16px 40px rgba(0,0,0,.55);max-height:70vh;overflow-y:auto;}" +
      ".predictive__section-title{padding:10px 14px 4px;font:600 11px var(--font-display);" +
      "letter-spacing:.06em;text-transform:uppercase;color:var(--text-dim);}" +
      ".predictive__item{display:flex;gap:12px;padding:10px 14px;align-items:center;}" +
      ".predictive__item:hover,.predictive__item.is-focus{background:var(--surface-2);}" +
      ".predictive__item img{width:44px;height:44px;border-radius:8px;background:var(--tile);object-fit:contain;flex-shrink:0;}" +
      ".predictive__item strong{display:block;font:500 13px/1.3 var(--font-body);color:var(--text);}" +
      ".predictive__item strong mark{background:none;color:var(--accent);font-weight:700;padding:0;}" +
      ".predictive__item em{font:600 12px var(--font-display);color:var(--accent);font-style:normal;}" +
      ".predictive__links{padding:2px 6px 8px;}" +
      ".predictive__links a{display:block;padding:8px 8px;border-radius:8px;font-size:13px;color:var(--text);}" +
      ".predictive__links a:hover{background:var(--surface-2);color:var(--accent);}" +
      ".predictive__all{display:block;padding:11px;text-align:center;font:600 11px var(--font-display);" +
      "letter-spacing:.08em;text-transform:uppercase;color:var(--accent);border-top:1px solid var(--line);}" +
      ".predictive__all:hover{background:var(--surface-2);}" +
      ".predictive__empty{padding:16px;color:var(--text-dim);font-size:13px;}" +
      ".predictive__divider{border-top:1px solid var(--line);margin:4px 0;}" +
      ".predictive__recent{display:flex;flex-wrap:wrap;gap:8px;padding:2px 14px 12px;}" +
      ".predictive__chip{border:1px solid var(--line);border-radius:999px;padding:6px 12px;font-size:12px;color:var(--text);background:none;cursor:pointer;}" +
      ".predictive__chip:hover{border-color:var(--accent);color:var(--accent);}" +
      ".predictive__close{display:none;}" +
      "@media (max-width:" + MOBILE_BQ + "px){" +
      ".search-bar.is-fullscreen{position:fixed;inset:0;z-index:999;background:var(--surface);" +
      "display:flex;flex-direction:column;padding:16px 54px 16px 16px;border-radius:0;width:100%;}" +
      ".search-bar.is-fullscreen input[type=search]{flex:0 0 auto;width:100%;font-size:16px;}" +
      ".search-bar.is-fullscreen button[type=submit]{display:none;}" +
      ".search-bar.is-fullscreen .predictive{position:static;flex:1;margin-top:12px;border-radius:8px;" +
      "max-height:none;box-shadow:none;overflow-y:auto;}" +
      ".search-bar.is-fullscreen .predictive__close{display:flex;position:absolute;top:14px;right:14px;" +
      "align-items:center;justify-content:center;width:36px;height:36px;flex-shrink:0;border:none;" +
      "background:none;color:var(--text);cursor:pointer;z-index:1;}" +
      "body.search-lock-scroll{overflow:hidden;}" +
      "}";
    document.head.appendChild(css);

    function cdnResize(url, w) {
      if (!url) return "";
      try {
        var u = new URL(url, window.location.origin);
        u.searchParams.set("width", w);
        return u.href;
      } catch (e) { return url; }
    }

    function esc(s) { return String(s || "").replace(/</g, "&lt;"); }

    function highlight(text, needle) {
      if (!needle) return esc(text);
      var words = needle.toLowerCase().split(/\s+/).filter(function (w) { return w.length > 1; });
      var out = esc(text);
      words.forEach(function (w) {
        var re = new RegExp("(" + w.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") + ")", "ig");
        out = out.replace(re, "<mark>$1</mark>");
      });
      return out;
    }

    /* ----- Recent searches (localStorage) ----- */
    function getRecent() {
      try { return JSON.parse(localStorage.getItem(RECENT_KEY)) || []; } catch (e) { return []; }
    }
    function pushRecent(term) {
      term = term.trim();
      if (!term) return;
      try {
        var list = getRecent().filter(function (t) { return t.toLowerCase() !== term.toLowerCase(); });
        list.unshift(term);
        localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, 5)));
      } catch (e) { /* storage unavailable — skip */ }
    }
    function getViewed() {
      try { return JSON.parse(localStorage.getItem(VIEWED_KEY)) || []; } catch (e) { return []; }
    }

    /* ----- Analytics: fire on every completed search / zero-result search ----- */
    function trackSearch(term, count) {
      try {
        window.dataLayer = window.dataLayer || [];
        var evt = count === 0 ? "search_no_results" : "search";
        window.dataLayer.push({ event: evt, search_term: term, results_count: count });
        if (typeof window.gtag === "function") {
          window.gtag("event", evt, { search_term: term, results_count: count });
        }
      } catch (e) { /* analytics best-effort only */ }
    }
    window.LuzTrackSearch = trackSearch;

    /* ----- Fuzzy correction index (lazy-loaded once, cached) ----- */
    var fuseReady = null;
    function loadFuzzyIndex() {
      if (fuseReady) return fuseReady;
      fuseReady = Promise.all([
        new Promise(function (resolve, reject) {
          if (window.Fuse) return resolve();
          var s = document.createElement("script");
          s.src = "https://cdnjs.cloudflare.com/ajax/libs/fuse.js/6.6.2/fuse.min.js";
          s.onload = resolve;
          s.onerror = reject;
          document.head.appendChild(s);
        }),
        fetch((window.LuzAssetUrls && window.LuzAssetUrls.searchIndex) || (root + "assets/search-index.json")).then(function (r) { return r.json(); }),
      ]).then(function (res) {
        var data = res[1];
        var fuse = new window.Fuse(data.terms, { includeScore: true, threshold: 0.4 });
        return { fuse: fuse, data: data };
      }).catch(function () { return null; });
      return fuseReady;
    }

    function correctQuery(q) {
      return loadFuzzyIndex().then(function (idx) {
        if (!idx) return null;
        var words = q.toLowerCase().split(/\s+/).filter(function (w) { return w.length > 2; });
        var corrected = words.map(function (w) {
          var hit = idx.fuse.search(w, { limit: 1 })[0];
          return hit && hit.score < 0.4 ? hit.item : w;
        });
        var result = corrected.join(" ");
        return result !== q.toLowerCase() ? result : null;
      });
    }

    function matchCategoryLinks(q) {
      return loadFuzzyIndex().then(function (idx) {
        if (!idx) return [];
        var needle = q.toLowerCase();
        var typeHandles = {
          "mens footwear": "men-footwear", "mens clothing": "men-clothing", "mens accessories": "men-accessories",
          "womens footwear": "women-footwear", "womens clothing": "women-clothing", "womens accessories": "women-accessories",
        };
        var vendorHandles = {
          adidas: "adidas", asics: "asics", jordan: "jordan", "new balance": "new-balance",
          nike: "nike", "on running": "on-running", puma: "puma", "under armour": "under-armour",
        };
        var links = [];
        idx.data.types.forEach(function (t) {
          if (t.toLowerCase().indexOf(needle) !== -1 || needle.indexOf(t.toLowerCase().split(" ")[1] || "") !== -1) {
            var handle = typeHandles[t.toLowerCase()];
            if (handle) links.push({ label: t, url: root + "collections/" + handle });
          }
        });
        idx.data.vendors.forEach(function (v) {
          if (v.toLowerCase().indexOf(needle) !== -1 || needle.indexOf(v.toLowerCase()) !== -1) {
            var handle = vendorHandles[v.toLowerCase()];
            var url = handle ? root + "collections/" + handle : root + "collections/all?filter.p.vendor=" + encodeURIComponent(v);
            links.push({ label: v, url: url });
          }
        });
        var seen = {};
        return links.filter(function (l) { return seen[l.label] ? false : (seen[l.label] = true); }).slice(0, 4);
      });
    }

    async function suggestAll(q, signal) {
      var res = await fetch(
        root + "search/suggest.json?q=" + encodeURIComponent(q) +
        "&resources[type]=product,collection,page,article&resources[limit]=6" +
        "&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,variants.title,vendor,tag",
        { signal: signal }
      );
      var data = await res.json();
      var results = (data.resources && data.resources.results) || {};
      return {
        products: results.products || [],
        collections: results.collections || [],
        pages: results.pages || [],
        articles: results.articles || [],
      };
    }

    function initPredictive(form) {
      var input = form.querySelector('input[type="search"]');
      if (!input || form.dataset.predictive) return;
      form.dataset.predictive = "1";
      if (getComputedStyle(form).position === "static") form.style.position = "relative";
      var box = document.createElement("div");
      box.className = "predictive";
      box.hidden = true;
      form.appendChild(box);

      var closeBtn = document.createElement("button");
      closeBtn.type = "button";
      closeBtn.className = "predictive__close";
      closeBtn.setAttribute("aria-label", "Close search");
      closeBtn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 6l12 12M18 6L6 18"/></svg>';
      form.insertBefore(closeBtn, form.firstChild);

      var timer, ctrl;
      input.setAttribute("autocomplete", "off");

      function exitFullscreen() {
        form.classList.remove("is-fullscreen");
        document.body.classList.remove("search-lock-scroll");
        box.hidden = true;
      }
      closeBtn.addEventListener("click", exitFullscreen);

      function renderPersonalized() {
        var recent = getRecent();
        var viewed = getViewed();
        if (!recent.length && !viewed.length) { box.hidden = true; return; }
        var html = "";
        if (recent.length) {
          html += '<div class="predictive__section-title">Recent searches</div>' +
            '<div class="predictive__recent">' +
            recent.map(function (t) {
              return '<button type="button" class="predictive__chip" data-recent-term="' + esc(t) + '">' + esc(t) + "</button>";
            }).join("") + "</div>";
        }
        if (viewed.length) {
          html += '<div class="predictive__section-title">Recommended for you</div>' +
            viewed.slice(0, 4).map(function (p) {
              return '<a class="predictive__item" href="' + p.url + '">' +
                '<img src="' + cdnResize(p.image, 88) + '" alt="" loading="lazy">' +
                "<span><strong>" + esc(p.title) + "</strong>" +
                (p.price ? "<em>$" + p.price + "</em>" : "") +
                "</span></a>";
            }).join("");
        }
        box.innerHTML = html;
        box.hidden = false;
        box.querySelectorAll("[data-recent-term]").forEach(function (chip) {
          chip.addEventListener("click", function () {
            input.value = chip.dataset.recentTerm;
            input.dispatchEvent(new Event("input"));
          });
        });
      }

      function renderResults(res, q, usedQuery, categoryLinks) {
        var note = usedQuery && usedQuery !== q
          ? '<div class="predictive__empty" style="padding:10px 14px 4px;">Showing results for “' + esc(usedQuery) + '”</div>'
          : "";
        var productHtml = "";
        if (res.products.length) {
          productHtml = '<div class="predictive__section-title">Suggested products</div>' +
            res.products.map(function (p) {
              var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || "");
              return '<a class="predictive__item" href="' + p.url + '">' +
                '<img src="' + cdnResize(img, 88) + '" alt="" loading="lazy">' +
                "<span><strong>" + highlight(p.title, usedQuery || q) + "</strong>" +
                (p.price ? "<em>$" + p.price + "</em>" : "") +
                "</span></a>";
            }).join("");
        }
        var catLinks = (categoryLinks || []).concat(
          res.collections.map(function (c) { return { label: c.title, url: c.url }; })
        );
        var seenCat = {};
        catLinks = catLinks.filter(function (l) { return l.label && !seenCat[l.label] && (seenCat[l.label] = true); }).slice(0, 4);
        var catHtml = catLinks.length
          ? '<div class="predictive__section-title">Matching categories</div><div class="predictive__links">' +
            catLinks.map(function (l) { return '<a href="' + l.url + '">' + esc(l.label) + "</a>"; }).join("") + "</div>"
          : "";
        var articles = res.pages.concat(res.articles);
        var articleHtml = articles.length
          ? '<div class="predictive__section-title">Articles &amp; pages</div><div class="predictive__links">' +
            articles.slice(0, 3).map(function (a) { return '<a href="' + a.url + '">' + esc(a.title) + "</a>"; }).join("") + "</div>"
          : "";

        if (!productHtml && !catHtml && !articleHtml) {
          box.innerHTML = '<div class="predictive__empty">No results for “' + esc(q) + '”</div>' +
            '<a class="predictive__all" href="' + root + 'search?q=' + encodeURIComponent(q) + '&type=product">Search anyway →</a>';
          box.hidden = false;
          return;
        }

        box.innerHTML = note + productHtml +
          (productHtml && (catHtml || articleHtml) ? '<div class="predictive__divider"></div>' : "") +
          catHtml + articleHtml +
          '<a class="predictive__all" href="' + root + 'search?q=' + encodeURIComponent(usedQuery || q) + '&type=product">See all results →</a>';
        box.hidden = false;
      }

      input.addEventListener("input", function () {
        clearTimeout(timer);
        var q = input.value.trim();
        if (!q.length) { renderPersonalized(); return; }
        if (q.length < 2) { box.hidden = true; return; }
        timer = setTimeout(async function () {
          try {
            if (ctrl) ctrl.abort();
            ctrl = new AbortController();
            var res = await suggestAll(q, ctrl.signal);

            if (res.products.length) {
              renderResults(res, q, q, []);
              trackSearch(q, res.products.length);
              return;
            }

            /* Zero exact matches — try client-side fuzzy correction against
               our own catalog vocabulary (handles "shrt" → "shirt"), then
               re-query Shopify with the corrected term for real, live
               thumbnails/prices. */
            var corrected = await correctQuery(q);
            if (corrected) {
              res = await suggestAll(corrected, ctrl.signal);
              if (res.products.length || res.collections.length) {
                var links = await matchCategoryLinks(corrected);
                renderResults(res, q, corrected, links);
                trackSearch(q, res.products.length);
                return;
              }
            }

            var catLinks = await matchCategoryLinks(q);
            if (catLinks.length) {
              renderResults(res, q, q, catLinks);
              trackSearch(q, 0);
              return;
            }

            box.innerHTML = '<div class="predictive__empty">No results for “' + esc(q) + '”</div>' +
              '<a class="predictive__all" href="' + root + 'search?q=' + encodeURIComponent(q) + '&type=product">Search anyway →</a>';
            box.hidden = false;
            trackSearch(q, 0);
          } catch (e) { /* aborted or offline — keep quiet */ }
        }, 220);
      });

      input.addEventListener("keydown", function (e) {
        if (e.key === "Escape") exitFullscreen();
      });
      document.addEventListener("click", function (e) {
        if (!form.contains(e.target)) exitFullscreen();
      });
      input.addEventListener("focus", function () {
        if (window.innerWidth <= MOBILE_BQ) {
          form.classList.add("is-fullscreen");
          document.body.classList.add("search-lock-scroll");
        }
        if (!input.value.trim().length) { renderPersonalized(); return; }
        if (box.innerHTML && input.value.trim().length >= 2) box.hidden = false;
      });
      form.addEventListener("submit", function () {
        if (input.value.trim()) pushRecent(input.value.trim());
      });
      box.addEventListener("click", function (e) {
        if (e.target.closest(".predictive__item, .predictive__links a") && input.value.trim()) {
          pushRecent(input.value.trim());
        }
      });
    }

    document.querySelectorAll('form[action*="search"]').forEach(initPredictive);
  })();

  /* ----- PDP gallery ----- */
  const mainImg = document.getElementById("GalleryMain");
  document.querySelectorAll("[data-thumb]").forEach((btn) => {
    btn.addEventListener("click", () => {
      if (!mainImg) return;
      mainImg.src = btn.dataset.thumb;
      mainImg.srcset = "";
      document.querySelectorAll("[data-thumb]").forEach((b) => b.classList.remove("is-active"));
      btn.classList.add("is-active");
    });
  });

  /* ----- PDP variant picker ----- */
  const productEl = document.querySelector("[data-product-json]");
  if (productEl) {
    let product;
    try { product = JSON.parse(productEl.textContent); } catch (e) { product = null; }
    if (product) {
      const idInput = document.getElementById("VariantId");
      const stockEl = document.getElementById("StockAlert");
      const atcBtns = document.querySelectorAll("[data-atc]");
      const priceEl = document.getElementById("BuyPrice");
      const money = (cents) => "$" + (cents / 100).toFixed(2);

      /* Record this product as "recently viewed" for the smart search bar's
         personalized "Recommended for you" panel. */
      try {
        const VIEWED_KEY = "luz_recently_viewed";
        const img = (product.featured_image || (product.images && product.images[0]) || "");
        const variant = (product.variants && product.variants[0]) || {};
        const shopRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
        const img2 = (product.images && product.images[1]) || "";
        /* url/title/image/price are the shape the search bar's
           "Recommended for you" panel already reads — keep them.
           The rest is what LuzCard needs to render a full product card
           in the PDP "Recently viewed" row without a second network call. */
        const entry = {
          url: shopRoot + "products/" + product.handle,
          title: product.title,
          image: typeof img === "string" ? img : "",
          price: variant.price ? (variant.price / 100).toFixed(2) : "",
          handle: product.handle,
          vendor: product.vendor || "",
          type: product.type || "",
          tags: product.tags || [],
          priceCents: variant.price || 0,
          compareCents:
            variant.compare_at_price && variant.compare_at_price > variant.price
              ? variant.compare_at_price
              : null,
          images: [typeof img === "string" ? img : "", typeof img2 === "string" ? img2 : ""].filter(Boolean),
          ts: Date.now(),
        };
        let viewed = [];
        try { viewed = JSON.parse(localStorage.getItem(VIEWED_KEY)) || []; } catch (e) { viewed = []; }
        viewed = viewed.filter((v) => v.url !== entry.url);
        viewed.unshift(entry);
        localStorage.setItem(VIEWED_KEY, JSON.stringify(viewed.slice(0, 12)));
      } catch (e) { /* storage unavailable — skip */ }

      document.querySelectorAll('input[name="size-option"]').forEach((radio) => {
        radio.addEventListener("change", () => {
          const variant = product.variants.find((v) => String(v.id) === radio.value);
          if (!variant) return;
          if (idInput) idInput.value = variant.id;
          if (priceEl) {
            priceEl.innerHTML =
              money(variant.price) +
              (variant.compare_at_price > variant.price
                ? " <s>" + money(variant.compare_at_price) + "</s>"
                : "");
            priceEl.classList.toggle("is-sale", variant.compare_at_price > variant.price);
          }
          atcBtns.forEach((b) => {
            b.disabled = !variant.available;
            b.textContent = variant.available ? b.dataset.labelAdd : b.dataset.labelSoldout;
          });
          if (stockEl) {
            const qty = variant.inventory_quantity;
            if (variant.available && typeof qty === "number" && qty > 0 && qty <= 3) {
              stockEl.textContent = "🔥 Only " + qty + " left in this size";
              stockEl.hidden = false;
            } else {
              stockEl.hidden = true;
            }
          }
        });
      });
    }
  }

  /* ====================================================================
     ADD TO CART — posts the real form data, surfaces real errors,
     never redirects to an empty cart.
     ==================================================================== */
  const productForm = document.getElementById("ProductForm");
  if (productForm) {
    productForm.addEventListener("submit", async (evt) => {
      evt.preventDefault();
      const btn = productForm.querySelector("[data-atc]");
      const idInput = document.getElementById("VariantId");
      if (!idInput || !idInput.value) {
        toast("Please select a size", true);
        return;
      }
      if (btn) { btn.disabled = true; btn.textContent = "Adding…"; }
      try {
        const fd = new FormData(productForm);
        if (!fd.get("quantity")) fd.append("quantity", "1");
        const res = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Accept": "application/json" },
          body: fd
        });
        const data = await res.json();
        if (!res.ok) {
          toast(data.description || data.message || "Couldn't add to bag — please try again", true);
          return;
        }
        const cart = await (await fetch("/cart.js", { headers: { "Accept": "application/json" } })).json();
        document.querySelectorAll("[data-cart-count]").forEach((el) => {
          el.textContent = cart.item_count;
          if (cart.item_count > 0) el.removeAttribute("data-zero");
        });
        if (window.LuzCartDrawer && typeof window.LuzCartDrawer.open === "function") {
          window.LuzCartDrawer.open(cart);
        } else {
          toast("Added to bag ✓", false);
        }
      } catch (e) {
        /* Network/context failure: fall back to a NATIVE form submit so
           the add still happens server-side (works even in the theme
           editor preview iframe where fetch cookies can be blocked). */
        HTMLFormElement.prototype.submit.call(productForm);
        return;
      } finally {
        if (btn) { btn.disabled = false; btn.textContent = btn.dataset.labelAdd || "Add to bag"; }
      }
    });
  }

  /* ----- Sticky mobile ATC ----- */
  const sticky = document.getElementById("StickyAtc");
  const buyBox = document.querySelector(".buy-actions");
  if (sticky && buyBox && "IntersectionObserver" in window) {
    new IntersectionObserver(
      (entries) => sticky.classList.toggle("is-visible", !entries[0].isIntersecting),
      { rootMargin: "-80px 0px 0px 0px" }
    ).observe(buyBox);
    sticky.querySelector("button")?.addEventListener("click", () => {
      buyBox.scrollIntoView({ behavior: "smooth", block: "center" });
    });
  }

  /* ----- Size guide modal ----- */
  const modal = document.getElementById("SizeGuideModal");
  document.querySelectorAll("[data-size-guide-open]").forEach((b) =>
    b.addEventListener("click", () => modal && modal.classList.add("is-open"))
  );
  document.querySelectorAll("[data-modal-close]").forEach((b) =>
    b.addEventListener("click", () => modal && modal.classList.remove("is-open"))
  );
  modal?.addEventListener("click", (e) => { if (e.target === modal) modal.classList.remove("is-open"); });

  /* ----- Cart quantity ----- */
  document.querySelectorAll("[data-qty-change]").forEach((btn) => {
    btn.addEventListener("click", async () => {
      const line = btn.dataset.line;
      const input = document.querySelector('input[data-qty-input="' + line + '"]');
      if (!input) return;
      const next = Math.max(0, Number(input.value) + Number(btn.dataset.qtyChange));
      try {
        const res = await fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", "Accept": "application/json" },
          body: JSON.stringify({ line: Number(line), quantity: next }),
        });
        if (!res.ok) { const d = await res.json(); toast(d.description || "Couldn't update quantity", true); return; }
        window.location.reload();
      } catch (e) {
        window.location.reload();
      }
    });
  });

  /* ====================================================================
     PRODUCT RECOMMENDATIONS (PDP) + RECENTLY VIEWED

     Shopify's /recommendations/products.json is a black box trained mostly
     on co-purchase behaviour. On a catalog like ours — one supplier feed,
     thousands of SKUs, thin order history — it happily returns women's
     leggings or a sports bra underneath a men's ASICS running shoe, because
     those items were bought in the same basket by somebody once.

     So we no longer trust its output directly. We ask it for a wide pool
     (intent=related, limit 12), then apply our own rules:

       HARD FILTERS (a candidate that fails is dropped outright)
         - category must match: footwear stays with footwear, clothing with
           clothing, accessories with accessories. This alone kills the
           "underwear on a running shoe" problem.
         - gender must not contradict. Both sides have to be confidently
           known before we reject, and genuinely unisex items (tagged both
           Men and Women — most caps, socks and bags are) are never rejected.

       RANKING (what survives is then scored)
         +4 same brand        — people shopping ASICS want more ASICS
         +3 same gender, exactly
         +2 price within 35%  — don't show a $60 tee next to a $280 sneaker
         +1 shares a model/style word with the title (e.g. "Gel", "9060")
         +1 in stock

     If fewer than 4 survive, we top up from the shopper's own
     gender+category collection (e.g. /collections/men-footwear) rather than
     padding with whatever the API returned — a same-category near-miss beats
     a cross-category "recommendation" every time.
     ==================================================================== */

  /* Map the /products.json response shape (prices as dollar strings,
     images as objects) onto the /recommendations shape LuzCard expects. */
  window.LuzMapProductsJson = function (p) {
    var v = (p.variants && p.variants[0]) || {};
    var priceRaw = parseFloat(v.price) || 0;
    var compareRaw = v.compare_at_price ? parseFloat(v.compare_at_price) : 0;
    return {
      id: p.id,
      handle: p.handle,
      title: p.title,
      vendor: p.vendor,
      type: p.product_type || "",
      tags: p.tags || [],
      available: !!(p.variants || []).some(function (x) { return x.available; }),
      price: Math.round(priceRaw * 100),
      compare_at_price: compareRaw > priceRaw ? Math.round(compareRaw * 100) : null,
      featured_image: p.images && p.images[0] ? p.images[0].src : "",
      images: (p.images || []).map(function (im) { return im.src; }),
    };
  };

  /* Derive (gender, category) from a product's type and tags.
     Order matters: test "women" before "men", because the string
     "womens footwear" contains "men". */
  window.LuzTaxonomy = function (p) {
    var type = String(p.type || p.product_type || "").toLowerCase();
    var tags = (p.tags || []).map(function (t) { return String(t).toLowerCase(); });
    var hasMen = tags.indexOf("men") !== -1;
    var hasWomen = tags.indexOf("women") !== -1;

    var gender = "";
    if (type.indexOf("women") !== -1) gender = "women";
    else if (type.indexOf("men") !== -1) gender = "men";
    if (!gender) {
      if (hasWomen && !hasMen) gender = "women";
      else if (hasMen && !hasWomen) gender = "men";
    }

    var category = "";
    if (type.indexOf("footwear") !== -1) category = "footwear";
    else if (type.indexOf("clothing") !== -1) category = "clothing";
    else if (type.indexOf("accessor") !== -1) category = "accessories";

    return { gender: gender, category: category, unisex: hasMen && hasWomen };
  };

  /* Words worth matching on: drop colours, filler and the brand name so
     "ASICS Gel NYC" scores against "Gel Kayano", not against every other
     product that happens to contain "black". */
  var STOP_WORDS = {
    the: 1, and: 1, with: 1, for: 1, men: 1, mens: 1, women: 1, womens: 1,
    "men's": 1, "women's": 1, shoe: 1, shoes: 1, black: 1, white: 1, grey: 1,
    gray: 1, blue: 1, red: 1, green: 1, pink: 1, cream: 1, navy: 1, junior: 1,
    juniors: 1, kids: 1, low: 1, high: 1, mid: 1, new: 1,
  };
  function styleWords(title, vendor) {
    var brand = String(vendor || "").toLowerCase().split(/\s+/);
    return String(title || "")
      .toLowerCase()
      .replace(/[^a-z0-9\s.-]/g, " ")
      .split(/\s+/)
      .filter(function (w) {
        return w.length > 1 && !STOP_WORDS[w] && brand.indexOf(w) === -1;
      });
  }

  const recsEl = document.getElementById("Recommendations");
  if (recsEl && window.Shopify && Shopify.routes) {
    (function () {
      var root = Shopify.routes.root;
      var baseEl = document.querySelector("[data-product-json]");
      var base = null;
      try { base = baseEl ? JSON.parse(baseEl.textContent) : null; } catch (e) { base = null; }
      if (!base) return;

      var baseTax = window.LuzTaxonomy(base);
      var baseVariant = (base.variants || [])[0] || {};
      var basePrice = baseVariant.price || 0;
      var baseWords = styleWords(base.title, base.vendor);
      var WANTED = 4;

      function compatible(c) {
        var t = window.LuzTaxonomy(c);
        if (baseTax.category && t.category && baseTax.category !== t.category) return false;
        if (baseTax.gender && t.gender && baseTax.gender !== t.gender && !t.unisex) return false;
        return true;
      }

      function score(c) {
        var t = window.LuzTaxonomy(c);
        var s = 0;
        if (c.vendor && base.vendor && c.vendor.toLowerCase() === base.vendor.toLowerCase()) s += 4;
        if (baseTax.gender && t.gender === baseTax.gender) s += 3;
        if (basePrice && c.price) {
          var delta = Math.abs(c.price - basePrice) / basePrice;
          if (delta <= 0.35) s += 2;
          else if (delta <= 0.6) s += 1;
        }
        var words = styleWords(c.title, c.vendor);
        for (var i = 0; i < words.length; i++) {
          if (baseWords.indexOf(words[i]) !== -1) { s += 1; break; }
        }
        if (c.available !== false) s += 1;
        return s;
      }

      function render(list) {
        if (!list.length) return;
        recsEl.querySelector(".grid").innerHTML = list
          .slice(0, WANTED)
          .map(function (p) { return window.LuzCard(p); })
          .join("");
        recsEl.hidden = false;
        window.LuzWishlist && window.LuzWishlist.refresh();
      }

      function backfillUrl() {
        var g = baseTax.gender;
        var c = baseTax.category;
        if (g && c) return root + "collections/" + g + "-" + c + "/products.json?limit=30";
        if (c) return root + "collections/" + c + "/products.json?limit=30";
        if (g) return root + "collections/" + g + "/products.json?limit=30";
        return null;
      }

      fetch(root + "recommendations/products.json?product_id=" + recsEl.dataset.productId + "&limit=12&intent=related")
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var pool = (data && data.products) || [];
          var kept = pool.filter(compatible);
          kept.sort(function (a, b) { return score(b) - score(a); });

          if (kept.length >= WANTED) { render(kept); return; }

          var url = backfillUrl();
          if (!url) { render(kept.length ? kept : pool); return; }

          var seen = {};
          seen[base.handle] = true;
          kept.forEach(function (p) { seen[p.handle] = true; });

          return fetch(url)
            .then(function (r) { return r.json(); })
            .then(function (extra) {
              var mapped = ((extra && extra.products) || [])
                .map(window.LuzMapProductsJson)
                .filter(function (p) { return !seen[p.handle] && compatible(p); });
              mapped.sort(function (a, b) { return score(b) - score(a); });
              var merged = kept.concat(mapped);
              render(merged.length ? merged : pool);
            })
            .catch(function () { render(kept.length ? kept : pool); });
        })
        .catch(function () {});
    })();
  }

  /* ====================================================================
     CUSTOM COLLECTION FILTERS — restores checkbox/price state from the
     URL on load (since we build our own filter list instead of reading
     collection.filters.active_values), and renders removable "active
     filter" pills. The actual filtering is still done server-side by
     Shopify via the native filter.* URL params — this just drives the UI.
     ==================================================================== */
  (function () {
    const form = document.getElementById("FacetForm");
    if (!form) return;

    const minInput = form.querySelector("[data-price-min]");
    const maxInput = form.querySelector("[data-price-max]");

    /* Re-syncs checkbox/price-input state from the current URL. Runs once on
       initial load (see the bottom of this IIFE) and is re-run by
       assets/plp-ajax.js after every AJAX filter/sort/page/back-button change.
       assets/plp-ajax.js deliberately never replaces this form itself (the
       shopper's own in-progress toggles stay exactly as they left them) — the
       one case that needs catching up is browser back/forward, where the URL
       moves without anyone touching a checkbox. Unlike a one-shot init this
       always assigns both true and false so repeat calls stay correct. */
    function restoreFromUrl() {
      const params = new URLSearchParams(window.location.search);
      form.querySelectorAll('input[type="checkbox"]:not(.gender-checkbox):not(.category-checkbox):not(.style-checkbox)').forEach((cb) => {
        cb.checked = params.getAll(cb.name).includes(cb.value);
      });
      if (minInput) minInput.value = params.get(minInput.name) || "";
      if (maxInput) maxInput.value = params.get(maxInput.name) || "";
      form.querySelectorAll("details").forEach((d) => {
        const hasChecked = d.querySelector('input[type="checkbox"]:checked');
        const hasPrice = d.contains(minInput) && (minInput?.value || maxInput?.value);
        d.open = d.open || !!(hasChecked || hasPrice);
      });
    }

    form.querySelectorAll("[data-price-preset]").forEach((btn) => {
      btn.addEventListener("click", () => {
        if (minInput) minInput.value = btn.dataset.min || "";
        if (maxInput) maxInput.value = btn.dataset.max || "";
        if (window.LuzAjaxFacets) { window.LuzAjaxFacets.submit(); } else { form.submit(); }
      });
    });

    /* Gender + Category: both navigate between the store's existing
       collections (men, women, footwear, clothing, accessories, and
       combo collections like men-footwear) instead of injecting
       filter.p.product_type — that filter silently does nothing until
       Search & Discovery's "Product type" filter is enabled in Admin
       (Settings → Apps → Search & Discovery → Filters → Edit filters).
       Linking to the real collections works today with no admin step,
       and preserves every other active filter param across the jump.
       HANDLE_INFO maps every collection this feature can land on back
       to its (gender, category) state so checkboxes restore correctly
       and switching one dimension recombines with whichever value is
       already active in the other. */
    const HANDLE_INFO = {
      all: { gender: "", category: "" },
      men: { gender: "men", category: "" },
      women: { gender: "women", category: "" },
      footwear: { gender: "", category: "footwear" },
      clothing: { gender: "", category: "clothing" },
      accessories: { gender: "", category: "accessories" },
      "men-footwear": { gender: "men", category: "footwear" },
      "men-clothing": { gender: "men", category: "clothing" },
      "men-accessories": { gender: "men", category: "accessories" },
      "women-footwear": { gender: "women", category: "footwear" },
      "women-clothing": { gender: "women", category: "clothing" },
      "women-accessories": { gender: "women", category: "accessories" },
    };

    /* ---------- STYLE (sub-category) ----------
       Gender + Category alone can't answer "show me leggings". Our catalog
       has no sub-category data to filter on: product_type is only the six
       coarse values (Mens/Womens x Footwear/Clothing/Accessories), and the
       product tags are supplier-feed noise (sku:, Scraped_, gemini_...).
       The only reliable signal for "this is a legging" is the product title.

       Shopify's native filters cannot match on title, so instead each style
       is a smart collection with a TITLE CONTAINS rule (created 2026-08-10).
       Selecting a style navigates to that collection and carries every other
       active filter param along, exactly like Gender and Category do — so
       Brand, Price, Size and Availability keep working on top of it, and each
       style gets its own crawlable URL (/collections/womens-leggings).

       `key` is what makes a style survive a gender switch: toggling Men on
       womens-hoodies lands on mens-hoodies rather than dumping the shopper
       back into the whole Men collection. */
    const STYLE_INFO = {
      "womens-leggings":    { gender: "women", category: "clothing",    key: "leggings" },
      "womens-sports-bras": { gender: "women", category: "clothing",    key: "sports-bras" },
      "womens-crop-tops":   { gender: "women", category: "clothing",    key: "crop-tops" },
      "womens-t-shirts":    { gender: "women", category: "clothing",    key: "t-shirts" },
      "womens-hoodies":     { gender: "women", category: "clothing",    key: "hoodies" },
      "womens-sweatshirts": { gender: "women", category: "clothing",    key: "sweatshirts" },
      "womens-jackets":     { gender: "women", category: "clothing",    key: "jackets" },
      "womens-shorts":      { gender: "women", category: "clothing",    key: "shorts" },
      "womens-pants":       { gender: "women", category: "clothing",    key: "pants" },
      "womens-skirts":      { gender: "women", category: "clothing",    key: "skirts" },
      "mens-t-shirts":      { gender: "men",   category: "clothing",    key: "t-shirts" },
      "mens-polos":         { gender: "men",   category: "clothing",    key: "polos" },
      "mens-hoodies":       { gender: "men",   category: "clothing",    key: "hoodies" },
      "mens-sweatshirts":   { gender: "men",   category: "clothing",    key: "sweatshirts" },
      "mens-jackets":       { gender: "men",   category: "clothing",    key: "jackets" },
      "mens-shorts":        { gender: "men",   category: "clothing",    key: "shorts" },
      "mens-pants":         { gender: "men",   category: "clothing",    key: "pants" },
      "mens-track-pants":   { gender: "men",   category: "clothing",    key: "track-pants" },
      "mens-joggers":       { gender: "men",   category: "clothing",    key: "joggers" },
      "socks":              { gender: "",      category: "accessories", key: "socks" },
      "caps-hats":          { gender: "",      category: "accessories", key: "caps-hats" },
      "beanies":            { gender: "",      category: "accessories", key: "beanies" },
      "backpacks":          { gender: "",      category: "accessories", key: "backpacks" },
      "bags":               { gender: "",      category: "accessories", key: "bags" },
      "slides-sandals":     { gender: "",      category: "footwear",    key: "slides" },
      "for-runners":        { gender: "",      category: "footwear",    key: "running" },
      "basketball-sneakers":{ gender: "",      category: "footwear",    key: "basketball" },
    };

    /* Style collections are also valid landing pages for Gender/Category, so
       fold them into HANDLE_INFO — otherwise those checkboxes would render
       unchecked on /collections/womens-leggings. */
    Object.keys(STYLE_INFO).forEach((h) => {
      if (!HANDLE_INFO[h]) {
        HANDLE_INFO[h] = { gender: STYLE_INFO[h].gender, category: STYLE_INFO[h].category };
      }
    });

    /* key -> { men: handle, women: handle } for gender swapping. */
    const STYLE_BY_KEY = {};
    Object.keys(STYLE_INFO).forEach((h) => {
      const s = STYLE_INFO[h];
      STYLE_BY_KEY[s.key] = STYLE_BY_KEY[s.key] || {};
      STYLE_BY_KEY[s.key][s.gender || "any"] = h;
    });

    const collectionHandle = form.dataset.collectionHandle || "";
    const current = HANDLE_INFO[collectionHandle] || { gender: "", category: "" };
    const currentStyle = STYLE_INFO[collectionHandle] || null;

    function withParams(path) {
      const p = new URLSearchParams(window.location.search);
      p.delete("page");
      const qs = p.toString();
      return path + (qs ? "?" + qs : "");
    }

    function navigateTo(gender, category) {
      const target = gender && category ? gender + "-" + category : (gender || category || "all");
      window.location.href = withParams("/collections/" + target);
    }

    function navigateToStyle(handle) {
      window.location.href = withParams("/collections/" + handle);
    }

    form.querySelectorAll(".gender-checkbox").forEach((cb) => {
      if (cb.dataset.genderHandle === current.gender) cb.checked = true;
      cb.addEventListener("change", (evt) => {
        evt.stopPropagation();
        const nextGender = cb.checked ? cb.dataset.genderHandle : "";
        /* Keep the style if the same style exists for the newly chosen
           gender (womens-hoodies -> mens-hoodies). Genderless styles like
           socks are unaffected by the gender toggle, so leave them alone. */
        if (currentStyle && currentStyle.gender) {
          const sibling = nextGender && STYLE_BY_KEY[currentStyle.key]
            ? STYLE_BY_KEY[currentStyle.key][nextGender]
            : null;
          if (sibling) { navigateToStyle(sibling); return; }
        }
        navigateTo(nextGender, current.category);
      });
    });

    form.querySelectorAll(".category-checkbox").forEach((cb) => {
      if (cb.dataset.categoryHandle === current.category) cb.checked = true;
      cb.addEventListener("change", (evt) => {
        evt.stopPropagation();
        navigateTo(current.gender, cb.checked ? cb.dataset.categoryHandle : "");
      });
    });

    /* Style list: only offer styles that make sense in the current context.
       On /collections/women we hide men's styles; on a footwear collection we
       hide clothing styles. With no context at all (e.g. /collections/all)
       everything shows, grouped by the labels rendered in Liquid. */
    form.querySelectorAll(".style-checkbox").forEach((cb) => {
      const handle = cb.dataset.styleHandle;
      const info = STYLE_INFO[handle];
      const li = cb.closest("li");
      const isCurrent = handle === collectionHandle;

      if (info && li && !isCurrent) {
        const genderClash = current.gender && info.gender && info.gender !== current.gender;
        const catClash = current.category && info.category && info.category !== current.category;
        if (genderClash || catClash) { li.hidden = true; return; }
      }

      if (isCurrent) cb.checked = true;
      cb.addEventListener("change", (evt) => {
        evt.stopPropagation();
        if (cb.checked) { navigateToStyle(handle); return; }
        navigateTo(current.gender, current.category);
      });
    });

    /* If every style in a group got hidden, hide the group heading too. */
    form.querySelectorAll("[data-style-group]").forEach((group) => {
      const anyVisible = Array.prototype.some.call(
        group.querySelectorAll("li"),
        (li) => !li.hidden
      );
      if (!anyVisible) group.hidden = true;
    });

    /* Rebuilds the removable "active filter" pills. Re-queries #ActiveFacets
       fresh on every call rather than capturing it once: that element lives
       inside the #CollectionResults region that assets/plp-ajax.js replaces
       wholesale on every AJAX update, so a captured-once reference would go
       stale (detached from the document) after the first filter change. */
    function refreshActivePills() {
      const activeWrap = document.getElementById("ActiveFacets");
      if (!activeWrap) return;
      const pills = [];

      form.querySelectorAll('input[type="checkbox"]:checked:not(.gender-checkbox):not(.category-checkbox):not(.style-checkbox)').forEach((cb) => {
        const p = new URLSearchParams(window.location.search);
        const remaining = p.getAll(cb.name).filter((v) => v !== cb.value);
        p.delete(cb.name);
        remaining.forEach((v) => p.append(cb.name, v));
        const label = cb.closest("label")?.textContent.trim() || cb.value;
        const qs = p.toString();
        pills.push({ label, url: window.location.pathname + (qs ? "?" + qs : "") });
      });

      if (currentStyle) {
        const styleLabel =
          form.querySelector('.style-checkbox[data-style-handle="' + collectionHandle + '"]')
            ?.closest("label")?.textContent.trim() || collectionHandle;
        const qs = new URLSearchParams(window.location.search).toString();
        const fallback =
          current.gender && current.category
            ? current.gender + "-" + current.category
            : current.gender || current.category || "all";
        pills.push({ label: styleLabel, url: "/collections/" + fallback + (qs ? "?" + qs : "") });
      }

      if (current.gender) {
        const qs = new URLSearchParams(window.location.search).toString();
        pills.push({
          label: current.gender === "men" ? "Men" : "Women",
          url: "/collections/" + (current.category || "all") + (qs ? "?" + qs : ""),
        });
      }

      if (current.category) {
        const catLabel = current.category.charAt(0).toUpperCase() + current.category.slice(1);
        const qs = new URLSearchParams(window.location.search).toString();
        pills.push({
          label: catLabel,
          url: "/collections/" + (current.gender || "all") + (qs ? "?" + qs : ""),
        });
      }

      if ((minInput && minInput.value) || (maxInput && maxInput.value)) {
        const p = new URLSearchParams(window.location.search);
        if (minInput) p.delete(minInput.name);
        if (maxInput) p.delete(maxInput.name);
        const qs = p.toString();
        pills.push({ label: "Price", url: window.location.pathname + (qs ? "?" + qs : "") });
      }

      if (pills.length) {
        const clearPath = (currentStyle || current.gender || current.category) ? "/collections/all" : window.location.pathname;
        activeWrap.hidden = false;
        activeWrap.innerHTML =
          pills.map((p) => '<a href="' + p.url + '">' + p.label.replace(/</g, "&lt;") + " ✕</a>").join("") +
          '<a href="' + clearPath + '">Clear all</a>';
      } else {
        activeWrap.hidden = true;
        activeWrap.innerHTML = "";
      }
    }

    restoreFromUrl();
    refreshActivePills();

    /* Exposed for assets/plp-ajax.js: re-sync this form's own state and the
       active-pills row after every AJAX-driven URL change (filter, sort,
       pagination, pill removal, or browser back/forward). */
    window.LuzFacetSync = { restoreFromUrl, refreshActivePills };
  })();

  /* ----- Search: "no results" best-sellers fallback grid ----- */
  const noResultsGrid = document.querySelector("[data-noresults-grid]");
  if (noResultsGrid && window.Shopify && Shopify.routes) {
    function mapProductsJson(p) {
      var v = (p.variants && p.variants[0]) || {};
      var compareRaw = v.compare_at_price ? parseFloat(v.compare_at_price) : 0;
      var priceRaw = parseFloat(v.price) || 0;
      return {
        handle: p.handle,
        title: p.title,
        vendor: p.vendor,
        price: Math.round(priceRaw * 100),
        compare_at_price: compareRaw > priceRaw ? Math.round(compareRaw * 100) : null,
        featured_image: p.images && p.images[0] ? p.images[0].src : "",
        images: (p.images || []).map(function (im) { return im.src; }),
      };
    }
    fetch(Shopify.routes.root + "collections/all/products.json?sort_by=best-selling&limit=8")
      .then((r) => r.json())
      .then((data) => {
        if (!data.products || !data.products.length) return;
        noResultsGrid.innerHTML = data.products.map((p) => window.LuzCard(mapProductsJson(p))).join("");
        window.LuzWishlist && window.LuzWishlist.refresh();
      })
      .catch(() => {});
  }

  /* ----- Blog share bar ----- */
  document.querySelectorAll("[data-share]").forEach((bar) => {
    const payload = {
      title: bar.dataset.shareTitle || document.title,
      text: bar.dataset.shareText || "",
      url: bar.dataset.shareUrl || window.location.href,
    };
    const nativeBtn = bar.querySelector("[data-share-native]");
    if (nativeBtn && navigator.share) {
      nativeBtn.hidden = false;
      nativeBtn.addEventListener("click", () => {
        navigator.share(payload).catch(() => {});
      });
    }
    const copyBtn = bar.querySelector("[data-share-copy]");
    if (copyBtn) {
      copyBtn.addEventListener("click", async () => {
        try {
          await navigator.clipboard.writeText(payload.url);
          toast("Link copied");
        } catch (e) {
          toast("Couldn't copy link", true);
        }
      });
    }
  });

  /* ----- Shared JS product card renderer (recommendations + wishlist) ----- */
  window.LuzCard = function (p) {
    const img = p.featured_image || (p.images && p.images[0]) || "";
    const img2 = p.images && p.images[1] ? p.images[1] : null;
    const price = (p.price / 100).toFixed(2);
    const compare = p.compare_at_price && p.compare_at_price > p.price
      ? (p.compare_at_price / 100).toFixed(2) : null;
    const cdn = (src, w) => {
      if (!src) return "";
      try {
        const u = new URL(src, window.location.origin);
        u.searchParams.set("width", w);
        return u.href;
      } catch (e) { return src; }
    };
    /* These cards used to ship a single 533px-wide file to every device,
       including phones that paint the card at ~183 CSS px. PageSpeed flagged
       eight of them on one product page ("larger than it needs to be").

       CARD_SIZES must stay byte-identical to the `sizes` attribute in
       snippets/card-product.liquid — see the comment there for why it
       subtracts the gutter and page padding rather than using a plain 50vw,
       and why it stops scaling at 1520px. */
    const CARD_SIZES = "(min-width: 1520px) 330px, (min-width: 1200px) calc(25vw - 28px), (min-width: 750px) calc(33vw - 22px), calc(50vw - 24px)";
    const cdnSet = (s) => !s ? "" :
      [240, 360, 533, 720].map((w) => cdn(s, w) + " " + w + "w").join(", ");
    const esc = (s) => String(s == null ? "" : s)
      .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
    return (
      '<div class="card">' +
      '<button type="button" class="wish-btn" data-wishlist-toggle data-handle="' + p.handle + '" aria-label="Add to wishlist">' +
      '<svg viewBox="0 0 24 24"><path d="M12 21s-7.5-4.8-10-9.3C.6 8.1 2.6 4.5 6.2 4.5c2.1 0 3.7 1.1 4.8 2.8 1.1-1.7 2.7-2.8 4.8-2.8 3.6 0 5.6 3.6 4.2 7.2C19.5 16.2 12 21 12 21z"/></svg></button>' +
      '<a href="/products/' + p.handle + '">' +
      '<div class="card-media">' +
      (compare ? '<div class="card__badges"><span class="badge badge--sale">Sale</span></div>' : "") +
      '<img class="card-media__base" src="' + cdn(img, 360) + '" srcset="' + cdnSet(img) +
        '" sizes="' + CARD_SIZES + '" alt="' + esc(p.title) +
        '" loading="lazy" decoding="async">' +
      (img2 ? '<img class="card-media__hover" src="' + cdn(img2, 360) + '" srcset="' + cdnSet(img2) +
        '" sizes="' + CARD_SIZES + '" alt="" loading="lazy" decoding="async" aria-hidden="true">' : "") +
      "</div>" +
      '<div class="card__info">' +
      '<div class="card__vendor">' + (p.vendor || "") + "</div>" +
      '<div class="card__title">' + p.title + "</div>" +
      '<div class="card__price"><span class="' + (compare ? "is-sale" : "") + '">$' + price + "</span>" +
      (compare ? "<s>$" + compare + "</s>" : "") +
      "</div></div></a></div>"
    );
  };

  /* ----- Recently viewed (PDP) -----
     Reads the visitor's own history out of localStorage. Nothing is stored
     server-side and nothing is fetched, so this adds no requests and does
     not break full-page caching. The current product is filtered out, and
     the whole row stays hidden until there is at least one other item. */
  const recentEl = document.getElementById("RecentlyViewed");
  if (recentEl) {
    (function () {
      var KEY = "luz_recently_viewed";
      var currentHandle = recentEl.dataset.currentHandle || "";

      function read() {
        try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
      }

      function paint() {
        var items = read().filter(function (v) {
          /* Entries written before this feature shipped have no handle —
             skip them rather than rendering a broken card. */
          return v && v.handle && v.handle !== currentHandle;
        });
        if (!items.length) { recentEl.hidden = true; return; }
        recentEl.querySelector(".grid").innerHTML = items
          .slice(0, 8)
          .map(function (v) {
            return window.LuzCard({
              handle: v.handle,
              title: v.title,
              vendor: v.vendor,
              price: v.priceCents || Math.round(parseFloat(v.price || 0) * 100),
              compare_at_price: v.compareCents || null,
              featured_image: v.image,
              images: v.images || [v.image],
            });
          })
          .join("");
        recentEl.hidden = false;
        window.LuzWishlist && window.LuzWishlist.refresh();
      }

      var clearBtn = recentEl.querySelector("[data-clear-recent]");
      if (clearBtn) {
        clearBtn.addEventListener("click", function () {
          try { localStorage.removeItem(KEY); } catch (e) { /* ignore */ }
          recentEl.hidden = true;
        });
      }

      paint();
    })();
  }
})();